module.exports = __webpack_public_path__ + "static/media/log-1.47ae5d12.glb";